import * as yup from "yup";

const supportedFormats = ["image/jpeg", "image/png", "application/pdf"];

// NOTE: for images, if its not mandatory, keep the default value as ""
const fileSchema = yup
  .mixed()
  .required("File is required")
  .test("required", `File is required`, (value) => {
    if (value == "") return true;
    return (
      value instanceof File ||
      (typeof value === "object" && value !== null && "url" in value)
    );
  })
  .test("fileType", `Unsupported File Format`, (value) => {
    if (value == "") return true;
    if (value instanceof File) {
      return supportedFormats.includes(value.type);
    }
    if (typeof value === "object" && value !== null && "url" in value) {
      return true;
    }
    return false;
  });

export const customerDetailsStep1 = yup.object({
  outletName: yup.string().required("Outlet Name is required"),
  companyGST: yup.string().required("GST Number is required"),
  companyPAN: yup.string().required("PAN Number is required"),
  registeredAddress: yup.string().required("Registered Address is required"),
  authorizedSignatory: yup.string(),
  vatNumber: yup.string(),
  pincode: yup
    .string()
    .required("Pincode is required")
    .matches(/^\d+$/, "Pincode must be a number"),
  emailID: yup
    .string()
    .required("Email is required")
    .email("Email is not valid"),
  gstStateCode: yup.string(),
  comp_gst_cert: fileSchema,
  comp_pan_card: fileSchema,
  comp_vat_cert: fileSchema,
  phoneNumber: yup.string(),
});

export const customerDetailsStep2 = yup.object({
  licenseName: yup.string().required("License Name is required"),
  customerExciseRegistrationNumber: yup
    .string()
    .required("Customer Excise Registration Number is required"),
  licensePAN: yup.string().required("License PAN Number is required"),
  licenseGST: yup.string(),
  licenseAddress: yup.string().required("License Address is required"),
  gstStateCode: yup.string().required("GST State Code is required"),
  ksbclCode: yup.string().required("KSBCL Code is required"),

  lic_rvb_license: fileSchema,
  lic_license_pan: fileSchema,
  lic_gst_cert: fileSchema,
});

export const customerDetailsStep3 = yup.object({
  bankName: yup.string().required("Bank Name is required"),
  bankBranch: yup.string().required("Bank Branch is required"),
  accountType: yup.string(),
  accountNumber: yup.string().required("Account Number is required"),
  ifscCode: yup.string().required("IFSC Code is required"),
  beneficiaryName: yup.string().required("Beneficiary Name is required"),
  accountsDepartmentPOCName: yup.string(),
  accountsDepartmentPOCNumber: yup.string(),
  bank_cancelled_cheque: fileSchema,
});
